export const isValidDate = (date: Date) => {
  return date instanceof Date && !isNaN(date.getTime())
}

export const isValidDateString = (dateStr: string): boolean => {
  const [day, month, year] = dateStr.split('/').map(Number)
  const date = new Date(year, month - 1, day)

  return (
    date.getFullYear() === year &&
    date.getMonth() + 1 === month &&
    date.getDate() === day
  )
}

export const isValidTimeString = (timeStr: string): boolean => {
  const timeRegex = /^(\d{1,2}):(\d{1,2})$/;
  const match = timeStr.match(timeRegex);

  if (!match) return false

  const hours = parseInt(match[1]);
  const minutes = parseInt(match[2]);

  return (
    hours >= 0 && hours < 24 &&
    minutes >= 0 && minutes < 60
  );
}
